import { useContext } from "react";
import { getCustomMapRowContent } from "common-client/utils/firms";
import { AccountPropertyAttribute } from "../../../../generated/graphql";
import { AuthContext } from "../../../Authorization/AuthContext";
import {
  TableCell,
  TableCellContainer,
  TableRow,
} from "../../../Common/__styles__/StripedTable";
import { Icon } from "../../../Common/Icons/LucideIcons";
import { Label, PropertyAttributeLinkContainer } from "../__styles__";
import { RenderMode } from "../FIRMInfo/types";
import { PropertyOverviewContext } from "../PropertyOverviewContext";
import { PropertyOverviewTooltip } from "./PropertyOverviewTooltip";

export const CustomMapRow = ({
  accountPropertyAttribute,
  size,
}: {
  accountPropertyAttribute: Pick<
    AccountPropertyAttribute,
    | "sourceId"
    | "displayValueAsLink"
    | "label"
    | "isPublic"
    | "tooltip"
    | "displayConfig"
  >;
  size: RenderMode;
}) => {
  const {
    sourceId,
    displayValueAsLink,
    label,
    isPublic: accountPropertyAttributeIsPublic,
    tooltip,
    displayConfig,
  } = accountPropertyAttribute;

  const tooltipElement = PropertyOverviewTooltip({
    tooltipMarkdown: tooltip,
  });
  const { customMapsInfo } = useContext(PropertyOverviewContext);
  const { isPublic } = useContext(AuthContext);

  const customMap = customMapsInfo.find(map => map.id === sourceId);

  if (!customMap) {
    return null;
  }

  const { value, defaultDisplay } = getCustomMapRowContent({
    map: customMap,
    displayConfig,
  });

  if (isPublic && !accountPropertyAttributeIsPublic) {
    return null;
  }
  if (!value && !defaultDisplay) {
    return null;
  }

  const CustomMapValue =
    displayValueAsLink && value ?
      () => {
        return (
          <PropertyAttributeLinkContainer>
            <span>
              <Icon iconName="link" color="contentInfo" size={16} />
            </span>
            <a href={value} target="_blank">
              Link
            </a>
          </PropertyAttributeLinkContainer>
        );
      }
    : () => {
        return <span>{value || defaultDisplay}</span>;
      };

  return (
    <TableRow header={false}>
      <TableCell containsTooltip>
        <TableCellContainer>
          <Label size={size}>{label}</Label>
          {tooltipElement}
        </TableCellContainer>
      </TableCell>
      <TableCell style={{ whiteSpace: "normal" }}>
        <CustomMapValue />
      </TableCell>
    </TableRow>
  );
};
